var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconePlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10.9813 9.01867H14.352C14.8947 9.01867 15.3333 9.45867 15.3333 10C15.3333 10.5427 14.8933 10.9813 14.352 10.9813H10.9813V14.352C10.9813 14.8947 10.5413 15.3333 10 15.3333C9.45733 15.3333 9.01867 14.8933 9.01867 14.352V10.9813H5.648C5.10533 10.9813 4.66667 10.5413 4.66667 10C4.66667 9.45867 5.10533 9.01867 5.648 9.01867H9.01867V5.648C9.01867 5.10533 9.45867 4.66667 10 4.66667C10.5427 4.66667 10.9813 5.10667 10.9813 5.648V9.01867Z",
    fill: "#3D7AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconePlain);
export default __webpack_public_path__ + "static/media/addIconePlain.352e239e5a6a57ba8a20bfdd53eb1f4a.svg";
export { ForwardRef as ReactComponent };